// extracted by mini-css-extract-plugin
export var active = "bG_bd";
export var heading = "bG_G";
export var label = "bG_cy";
export var nodeContainer = "bG_g0";
export var section = "bG_b";
export var video = "bG_gs";
export var videos = "bG_gZ";